module.exports = __webpack_public_path__ + "static/media/geren_3.182fd112.jpg";